// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"86c09385","645":"140b4ef6","753":"b70523e8"}[chunkId] + ".chunk.js";
};